import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoubleCheckmark1Small"><Path d="M19.2842 7.51367L12.9863 17.5342L11.7158 16.7363L18.0137 6.71582L19.2842 7.51367Z" fill="currentColor"/><Path d="M15.2832 7.51172L9.07422 17.4473L4.68945 13.0625L5.75 12.002L8.80078 15.0527L14.0117 6.7168L15.2832 7.51172Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark1Small;
